import { gql } from '@apollo/client';

export const CREATE_PACKAGE = gql`
  mutation CreatePackage($input: PackageInput!, $user: UserInput!) {
    createPackage(input: $input, user: $user) {
      id
      title
      description
      image
      groupSize
      category
      type
      departure
      departures {
        id
        departureDate
        returnDate
      }
      highlights
      included
      excluded
      cities
      countries
      airline {
        id
        name
        code
        logo
      }
      formulas {
        id
        name
        priceType
        perPersonPrice
        roomPrices {
          single
          double
          triple
        }
        hotels {
          id
          name
          stars
          image
          address
          amenities
          meals
          bookingUrl
        }
      }
      itinerary {
        id
        dayNumber
        title
        description
        activities
        meals {
          breakfast
          lunch
          dinner
        }
        accommodation
      }
    }
  }
`;

export const UPDATE_PACKAGE = gql`
  mutation UpdatePackage($id: Int!, $input: PackageInput!, $user: UserInput!) {
    updatePackage(id: $id, input: $input, user: $user) {
      id
      title
      description
      image
      groupSize
      category
      type
      departure
      departures {
        id
        departureDate
        returnDate
      }
      highlights
      included
      excluded
      cities
      countries
      airline {
        id
        name
        code
        logo
      }
      formulas {
        id
        name
        priceType
        perPersonPrice
        roomPrices {
          single
          double
          triple
        }
        hotels {
          id
          name
          stars
          image
          address
          amenities
          meals
          bookingUrl
        }
      }
      itinerary {
        id
        dayNumber
        title
        description
        activities
        meals {
          breakfast
          lunch
          dinner
        }
        accommodation
      }
    }
  }
`;

export const DELETE_PACKAGE = gql`
  mutation DeletePackage($id: Int!) {
    deletePackage(id: $id) {
      id
    }
  }
`;

export const UPLOAD_FILE = gql`
  mutation UploadFile($file: String!, $agencyName: String!, $fieldName: String!, $entityId: Int) {
    uploadFile(file: $file, agencyName: $agencyName, fieldName: $fieldName, entityId: $entityId) {
      url
    }
  }
`; 